import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import type { FC } from 'react';

/**
 * Someone's photo, falling back to their initials. Shared so a person looks the same in the nav, in
 * a list and on their own page — the fallback especially, which is otherwise re-derived per screen.
 */
export const UserAvatar: FC<{ imageUrl?: string | null; name: string; className?: string }> = ({
    imageUrl,
    name,
    className,
}) => (
    <Avatar className={className}>
        <AvatarImage src={imageUrl || undefined} alt={name} />
        <AvatarFallback>{initialsFor(name)}</AvatarFallback>
    </Avatar>
);

/** First and last initial, or the first two characters of a single word (an email included). */
export function initialsFor(name: string | null | undefined): string {
    const parts = name?.trim().split(/\s+/).filter(Boolean) ?? [];
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
    return `${parts[0]![0] ?? ''}${parts[parts.length - 1]![0] ?? ''}`.toUpperCase();
}
